<template>
  <v-card flat tile max-width="100%" height="100%">
    <v-card-title>
      <v-img
        @click="$router.push({name: 'main'}).catch()"
        contain max-width="250"
        class="mx-auto nitg__logo"
        src="@/assets/logo.png"
        alt="NITG Helpdesk Logo"></v-img>
    </v-card-title>
    <v-card-text>
      <v-list class="mt-12">
        <v-list-item-group>
          <v-list-item v-for="(item, i) in menu" :key="i"
                       @click="$router.push({ name: item.name }).catch()">
            <v-list-item-icon class="mr-4">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content v-text="$t(item.content)"></v-list-item-content>
          </v-list-item>
          <template v-if="auth">
            <v-list-item @click="getVisits(item.value)"
                         v-for="item in websites"
                         :key="item.text">
              <v-list-item-icon class="mr-4">
                <v-icon>mdi-earth</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                {{ item.text }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="logout">
              <v-list-item-icon class="mr-4">
                <v-icon>mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-content v-text="$t('sidenav.logout')"></v-list-item-content>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
      <locales-component/>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'SidenavComponent',
  data () {
    return {
      items: [
        {
          icon: 'mdi-email-edit-outline',
          content: 'sidenav.contact',
          route: 'contact'
        }
      ]
    }
  },
  methods: {
    logout () {
      this.$http.get('api/v2/auth/logout')
        .then((response) => {
          this.$auth.remove()
          this.$store.dispatch('logout', { show: true, type: 'success', message: response.data.message })
          this.$router.push({ name: 'main' }).catch()
        })
    },
    async getVisits (website) {
      await this.$store.dispatch('setWebsite', website)
      await this.$store.dispatch('setLoading', true)
      await this.$http.get('api/v2/auth/regions/grouped/7')
        .then(response => {
          this.$store.dispatch('setStatistic', response.data)
          this.$root.$emit('build-stats')
        })
        .finally(() => {
          this.$store.dispatch('setLoading', false)
        })
    }
  },
  computed: {
    menu () {
      return this.items
    },
    auth () {
      return !!this.$store.getters.GET_USER
    },
    visitInfo () {
      return this.$t('admin.dashboard.visit')
    },
    websites () {
      return this.$t('admin.dashboard.websites')
    }
  }
}
</script>

<style scoped>

</style>
